import React from 'react';

import QAmountField from 'components/QAmountField';

import { investmentTransactionEditFormHooks } from 'components/Forms/InvestmentTransactionEditForm/investmentTransactionEditFormHooks';
import { amountLabel } from './labels';
import { SecurityAndTagsFields } from './SecurityAndTagsFields';
import { numberFromInput } from './utils';

export function AmountFields(): React.JSX.Element {
  const amount = investmentTransactionEditFormHooks.useField('amount');
  const investmentTxnType = investmentTransactionEditFormHooks.useField('investmentTxnType');
  const { label, expectedSign } = amountLabel(investmentTxnType.value);

  return (
    <>
      <SecurityAndTagsFields />
      <QAmountField
        id='amount'
        editable
        label={label}
        sx={{ minWidth: 110 }}
        expectedSign={expectedSign}
        noNegatives
        value={Math.abs(amount.value ?? 0)}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          amount.onValueChange(numberFromInput(event.target.value))
        }
        error={amount.error}
        helperText={amount.helperText}
      />
    </>
  );
}
